import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form , Modal, Button } from 'react-bootstrap';
import { resetModel } from '../../../../store/components/modelSlice';
import { message } from 'antd';
import { putCarNo } from '../../../../services/dashboard/car';

const OiltruckCarmodal = () => {
    const [show, setShow] = useState(true);
    const dispatch = useDispatch();
    const content = useSelector((state) => state.model.data);
    const [employeeCode, setEmployeeCode] = useState(''); 
    const { contentType } = useSelector((state) => state.model);

    const handleSubmit = () => {
        const payload = {employeeCode: employeeCode}
    
        putCarNo(content.carNo , payload)
            .then(response => {
                if (!employeeCode ) {
                    return;
                }
                cancelHandler();
                message.success('更新成功')
            })
            .catch(error => {
                console.error('Error:', error);
            });
        };

    const cancelHandler = () => {
        setShow(false);
        dispatch(resetModel()); 
    };

    return (
            <Modal className='driver-model' show={ show } onHide={ cancelHandler } centered >
                <Modal.Header className="model_title" closeButton style={{color:'#fff'}}>修改油車銷顧</Modal.Header>
                <Modal.Body>
                    <div className="message-container">
                        <Form className='model-form-container'>
                            <Form.Group className='model-form-group'>
                                <Form.Label>新銷雇工號</Form.Label>
                                <Form.Control className='model-form-content' name='account' placeholder="請輸入新銷雇工號" onChange={(e) => setEmployeeCode(e.target.value)}/>
                            </Form.Group>
                        </Form>
                    </div>
                    <div className="button-container">
                        <Button variant="secondary" data-shadow onClick={ cancelHandler }>關閉</Button>
                        <Button variant="primary" data-shadow onClick={ handleSubmit }>儲存</Button>
                    </div>
                </Modal.Body>
            </Modal>
    )
};

export default OiltruckCarmodal;